import axios from "axios";
const responseFormat = { error: "", data: null };
const { API_BACKEND_HOST } = process.env;


export const newTheme = async (request) => {
  const languageId = localStorage.getItem("i18nextLng");
  try {
    const response = await axios.post(
      `${API_BACKEND_HOST}${languageId}/v1/Theme`,
      request
    );
    responseFormat.data = response;
    responseFormat.error = "";
    return responseFormat;
  } catch ({ response }) {
    responseFormat.error =
      response.data.errors || "Erro ao tentar criar o Tema";
    return responseFormat;
  }
};

export const updateTheme = async (id, request) => {
  const languageId = localStorage.getItem("i18nextLng");
  try {
    const response = await axios.put(
      `${API_BACKEND_HOST}${languageId}/v1/Theme/${id}`,
      request
    );
    responseFormat.data = response;
    responseFormat.error = "";
    return responseFormat;
  } catch ({ response }) {
    responseFormat.error =
      response.data.errors || "Erro ao tentar editar o Tema";
    return responseFormat;
  }
};

export const getAllThemes = async (params) => {
  try {
    const languageId = localStorage.getItem("i18nextLng");
    const { data } = await axios.get(`${API_BACKEND_HOST}${languageId}/v1/Committee/themes`, {
      params,
    });
    responseFormat.data = data;
    responseFormat.error = "";
    return responseFormat;
  } catch ({ response }) {
    responseFormat.error = "async";
    return responseFormat;
  }
};

export const getThemesById = async (id) => {
  try {
    const languageId = localStorage.getItem("i18nextLng");
    const { data } = await axios.get(
      `${API_BACKEND_HOST}${languageId}/v1/Theme/${id}`
    );
    responseFormat.data = data;
    responseFormat.error = "";
    return responseFormat;
  } catch ({ response }) {
    responseFormat.error = response.data.errors[0] || "async";
    return responseFormat;
  }
};


export const deleteTheme = async ( id ) => {
  try {
    
    const languageId = localStorage.getItem("i18nextLng");
    const { data } = await axios.delete(
      `${API_BACKEND_HOST}${languageId}/v1/Theme/${id}`
    );
    responseFormat.data = data;
    responseFormat.error = undefined;
    return responseFormat;
  } catch ({ response }) {
    responseFormat.error = response.data.errors || " ";
    return responseFormat;
  }
};